import React from 'react';
import { useTranslation } from 'react-i18next';
import { Typography } from '../../../../../../../ui-kit';
import { CountCard, CountCircle } from './style';

interface PickedCountProps {
    count: number;
}

const PickedCount = ({ count }: PickedCountProps) => {
    const { t } = useTranslation();
    return (
        <CountCard>
            <CountCircle>
                <Typography variant='h5' component="span" color='inherit'>
                    {count}
                </Typography>
            </CountCircle>
            <Typography variant='caption'>
                {t(`Ingredient in the list`, { count })}
            </Typography>
        </CountCard>
    );
};

export default PickedCount;
